import { batch, observable } from "@legendapp/state";

export type DriveBreadcrumb = {
  id: string;
  name: string;
};

export const googleDriveBrowser$ = observable({
  currentFolderId: "root",
  breadcrumbs: [{ id: "root", name: "My Drive" }] as DriveBreadcrumb[],
  selectedFileIds: {} as Record<string, true>,
  searchQuery: "",
});

export function navigateToFolder(folderId: string, folderName: string) {
  const crumbs = googleDriveBrowser$.breadcrumbs.peek();
  googleDriveBrowser$.currentFolderId.set(folderId);
  googleDriveBrowser$.breadcrumbs.set([...crumbs, { id: folderId, name: folderName }]);
  googleDriveBrowser$.selectedFileIds.set({});
}

export function navigateToBreadcrumb(index: number) {
  const crumbs = googleDriveBrowser$.breadcrumbs.peek();
  const next = crumbs.slice(0, index + 1);
  const target = next[next.length - 1];
  batch(() => {
    googleDriveBrowser$.breadcrumbs.set(next);
    googleDriveBrowser$.currentFolderId.set(target.id);
    googleDriveBrowser$.selectedFileIds.set({});
  });
}

export function toggleFileSelection(fileId: string) {
  const cur = googleDriveBrowser$.selectedFileIds.peek();
  if (cur[fileId]) {
    const { [fileId]: _, ...rest } = cur;
    googleDriveBrowser$.selectedFileIds.set(rest);
  } else {
    googleDriveBrowser$.selectedFileIds.set({ ...cur, [fileId]: true });
  }
}

export function clearFileSelection() {
  googleDriveBrowser$.selectedFileIds.set({});
}

export function setSearchQuery(query: string) {
  googleDriveBrowser$.searchQuery.set(query);
}

export function resetGoogleDriveBrowser() {
  batch(() => {
    googleDriveBrowser$.currentFolderId.set("root");
    googleDriveBrowser$.breadcrumbs.set([{ id: "root", name: "My Drive" }]);
    googleDriveBrowser$.selectedFileIds.set({});
    googleDriveBrowser$.searchQuery.set("");
  });
}
